import { Manage_user_service } from "../services/Manage_user_service";
import config from "../../config/config";
import router from "../router/router"
import { MessageBox, Loading } from 'element-ui';
import moment from 'moment';
const state = {
    tabledata: [],
    total: 0,
    formProfile: {
        admin_id: null,
        email: null,
        firstname: null,
        lastname: null,
        phoneNumber: null,
        departments: null,
        username: null
    },
    contact_form: {
        subject: '',
        content_th: ''
    },
    access_log_list : [],
    access_log_total : 0,
    confirm_modal: false,
    loading : false
};
const actions = {
    async search_user({ commit }, formdata) {
        commit('LOADING',true)
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_user_service.find_user(formdata)
        if(result.status == 200){
            commit('SET_DATA_TABLE', result.data)
            setTimeout(() => {
                commit('LOADING',false)
                loadingInstance.close()
            }, 250);
        }else{
            setTimeout(() => {
                commit('LOADING',false)
                loadingInstance.close()
            }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    },
    async delete_user({ commit }, user_id) {
        commit('LOADING',true)
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });  
        let result = await Manage_user_service.delete_user(user_id)
        if(result.status == 200){
            commit('REMOVE_USER',user_id)
            setTimeout(() => {
                commit('LOADING',false)
                loadingInstance.close()
            }, 250);
        }else{
            setTimeout(() => {
                commit('LOADING',false)
                loadingInstance.close()
            }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    },
    async getUser({ commit }, data) {
        let result = await Manage_user_service.getUser(data);
        if (result.status === 200) {
            commit("ADD_FORM_EDIT", result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {
                $cookies.remove('user_nbtc')
                router.push({ name: 'Login' })
            }).catch(() => {
                $cookies.remove('user_nbtc')
                router.push({ name: 'Login' })
            });
        }
    },
    async updateProfile() {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_user_service.updateProfile(state.formProfile);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('อัปเดตข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                // router.push({ path: 'Dashboard' }) // Dashboard
            }).catch(() => {
                // router.push({ path: 'Dashboard' }) // Dashboard
            })
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async changePassword({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_user_service.changePassword(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('เปลี่ยนรหัสสำเร็จ กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                $cookies.remove('user_nbtc')
                router.push({ name: 'Login' })
            }).catch(() => {
                $cookies.remove('user_nbtc')
                router.push({ name: 'Login' })
            })
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async getAccessLog({commit},filter){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        commit('LOADING', true)
        let result = await Manage_user_service.getAccessLog(filter)
        if(result.status === 200){
            commit('SET_ACCESS_LOG', result.data)
            setTimeout(function(){ loadingInstance.close() }, 250);
            setTimeout(() => {
                commit('LOADING', false)
            }, 250);
        }else{
            commit('LOADING', false)
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async sendProblem({commit}, formdata) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_user_service.sendProblem(formdata)
        if (result.status == 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('ส่งคำร้องเสร็จสิ้น', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                commit('RESET_CONTACT_FORM')
            })
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('เกิดความผิดพลาด กรุณาลองใหม่อีกครั้ง', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'error'
            })
        }
    },
    resetContactForm({commit}) {
        commit('RESET_CONTACT_FORM')
    },
    async comparePassword({commit}, user_data) {
        let result = await Manage_user_service.comparePassword(user_data)
        return result.data
    },
    async deleteAccountRequest({commit}, formProfile) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_user_service.deleteAccountRequest(formProfile)
        if (result.status == 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('ส่งคำร้องขอลบบัญชีเสร็จสิ้น', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                $cookies.remove('user_nbtc')
                router.push({ name: 'Login' })
            }).catch(() => {
                $cookies.remove('user_nbtc')
                router.push({ name: 'Login' })
            })
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('เกิดความผิดพลาด กรุณาลองใหม่อีกครั้ง', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'error'
            })
        }
    }
};

const mutations = {
    SET_DATA_TABLE(state, data) {
        state.tabledata = []
        state.total = data[0] ? data[0].total : 0
        for(let i in data){
            data[i].profile_image = data[i].profile_image ? data[i].profile_image : 'uploads/profile/161f69e4ac8729b1120968f152a64939.png'
            data[i].created_at = data[i].created_at ? moment(data[i].created_at).add(543,'Y').format('DD/MM/YYYY') : null
            data[i].updated_at = data[i].updated_at ? moment(data[i].updated_at).add(543,'Y').format('DD/MM/YYYY') : null
            data[i].latest_login = data[i].latest_login ? moment(data[i].latest_login).add(543,'Y').format('DD/MM/YYYY HH:mm') : null
            data[i].profile_image = data[i].profile_image ? config.API_URL+data[i].profile_image : null
        }
        state.tabledata = data
    },
    SIZE_PAGE(state, data) {
        state.total_page = data;
    },
    REMOVE_USER(state, data) {
        var index = state.tabledata.findIndex(user => user.user_id == data)
        state.tabledata[index].status = 'Inactive'
        MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
            confirmButtonText: 'ตกลง',
            showCancelButton: false,
            type: 'success'
        })
    },
    ADD_FORM_EDIT(state, data) {
        state.formProfile.admin_id = data.admin_id
        state.formProfile.email = data.email
        state.formProfile.firstname = data.first_name
        state.formProfile.lastname = data.last_name
        state.formProfile.phoneNumber = data.phone_number
        state.formProfile.departments = data.departments
        state.formProfile.username = data.username
    },
    SET_ACCESS_LOG(state, data){
        for(let item of data){
            item.create_at = moment(item.create_at).add(543,'Y').format('DD/MM/YYYY HH:mm')
            state.total = item.total
        }
        state.access_log_list = data
    },
    SET_TOTAL_LOG(state, data){
        state.access_log_total = data
    },
    LOADING(state, status){
        state.loading = status
    },
    RESET_CONTACT_FORM(state) {
        state.contact_form = {
            subject: '',
            content_th: ''
        }
    }
};

export const Manage_user = {
    namespaced: true,
    state,
    actions,
    mutations
};